<template>
  <div class="produceInformationThread table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      生產資訊
    </li>
    <b-table
      :items="produceInformationThreadItem"
      :fields="produceInformationThreadFields"
      class="text-center produceInformationThread-table-detail"
    >
      <template #head(item_title)="">
        <div class="produceInformationThread-table-line">
          <span class="produceInformationThread-table-item">項目</span>
          <span class="produceInformationThread-table-status">狀態</span>
        </div>
      </template>
      <template #cell(qty)="row" style="">
        {{ row.item["qty"].name }}:
        {{
          isNaN(Number(row.item["qty"].count))
            ? row.item["qty"].count
            : Number(row.item["qty"].count).toLocaleString("en-US")
        }}
      </template>
      <template #cell(standard_total_weight)="data">
        {{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}
      </template>
      <!-- {{ (398000).toLocaleString("en-US") }} -->
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "produceInformationThread",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      produceInformationThreadFields:
        "produceInformationThread/get_produceInformationThreadFields",
      produceInformationThreadItem:
        "produceInformationThread/get_produceInformationThreadItem",
    }),
  },
};
</script>

<style lang="scss">
.produceInformationThread-table-line {
  border-top: 2.8rem #cccccc solid; /*上邊框寬度等於表格第一行行高*/
  width: 0px; /*讓容器寬度為0*/
  height: 0px; /*讓容器高度為0*/
  border-left: 5rem #bdbdbd solid; /*左邊框寬度等於表格第一行第一格寬度*/
  position: relative; /*讓裡面的兩個子容器絕對定位*/
  color: #000000;
}
.produceInformationThread-table-item {
  font-style: normal;
  display: block;
  position: absolute;
  top: -43px;
  left: -40px;
  width: 2.8rem;
  font-family: "dfyuanstd-w5";
}
.produceInformationThread-table-status {
  font-style: normal;
  display: block;
  position: absolute;
  top: -20px;
  left: -85px;
  width: 2.8rem;
  font-family: "dfyuanstd-w5";
}

.produceInformationThread-table-detail thead th {
  border-top: 1px solid;
}
.produceInformationThread-table-detail th,
.produceInformationThread-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  vertical-align: middle !important;
}
.produceInformationThread-table-detail th:first-child,
.produceInformationThread-table-detail td:first-child {
  border-left: 1px solid;
}
.produceInformationThread-table-detail {
  margin-bottom: 0px;
}
.produceInformationThread-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.produceInformationThread-table-detail thead tr:last-child th:nth-child(1) {
  width: 5rem;
  min-width: 5rem;
}
.produceInformationThread-table-detail thead tr:last-child th:nth-child(2) {
  min-width: 10rem;
}
.produceInformationThread-table-detail thead tr:last-child th:nth-child(3) {
  min-width: 5rem;
}
.produceInformationThread-table-detail thead tr:last-child th:nth-child(4) {
  min-width: 8rem;
}
.produceInformationThread-table-detail thead tr:last-child th:nth-child(5) {
  min-width: 5rem;
}
.produceInformationThread-table-detail thead tr:last-child th:nth-child(6) {
  min-width: 5rem;
}
.produceInformationThread-table-detail tr td {
  background-color: #ffffff;
}
.produceInformationThread-table-detail tr td:nth-child(1) {
  background-color: #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/components/produceInformationThread.vue